module.exports = __webpack_public_path__ + "img/130505c45bf17c3176d750a15481b6dd.png";